import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoadingModule } from '@components/loading';
import { CsIconModule } from '@components/icon';
import { DirectivesModule } from '@directives/directives.module';
import { UserViewComponent } from './user-view.component';
import { UserProfileModule } from '../../user-profile/user-profile.module';
import { UserViewRegimenModule } from './user-regimen/user-view-regimen.module';
import { UserAssistantModule } from './user-assistant/user-assistant.module';
import { UserHomeModule } from './user-home/user-home.module';
import { UserExploreModule } from './user-explore/user-explore.module';
import { UserShopModule } from './user-shop/user-shop.module';
import {
    NotificationPermissionPopupComponent
} from './user-home/notification-permission/notification-permission-popup/notification-permission-popup.component';
import {
    NotificationBannerComponent
} from './user-home/notification-permission/notification-permission-banner/notification-permission-banner.component';
import { OnHoldPopupComponent } from './user-home/on-hold-popup/on-hold-popup.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        CsIconModule,
        DirectivesModule,
        LoadingModule,
        UserProfileModule,
        UserViewRegimenModule,
        UserAssistantModule,
        UserHomeModule,
        UserExploreModule,
        UserShopModule,
        NotificationPermissionPopupComponent,
        NotificationBannerComponent,
        OnHoldPopupComponent,
    ],
  declarations: [UserViewComponent],
})
export class UserViewModule {}
